// @flow
import React from 'react';

import type {PaymentMethod} from '@tectonics/commons/new-payment-methods/payment-method';
import {
  DisplayCryptocurrencyBrands,
} from '@tectonics/look-and-feel/volcanes/pages/page-opened-payment/payment-method/payment-method-selector/payment-method-item/display-brands/display-cryptocurrency-brands/display-cryptocurrency-brands';
import {cryptocurrencyOutgoingPaymentMapper} from '@tectonics/prs/cryptocurrency/outgoing-payment-mapper';
import {
  CryptocurrencyForm,
} from '@tectonics/look-and-feel/volcanes/pages/page-opened-payment/payment-method/cryptocurrency-form/cryptocurrency-form';

export const Cryptocurrency: PaymentMethod = {
  code: 'cryptocurrency',
  nameKey: 'volcanes.cryptocurrency.name',
  placeOrderMessageKey: 'volcanes.cryptocurrency.placeOrder',
  icons: <DisplayCryptocurrencyBrands />,
  outgoingPaymentMapper: cryptocurrencyOutgoingPaymentMapper,
  paymentMethodForm: <CryptocurrencyForm />,
};
